<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <v-alert type="error" text v-show="this.changementInterdit">
        <ressource code="changement-interdit" />
      </v-alert>

      <CatalogueLive
        code="categorie"
        v-model="sasAssurance.categorieDAssuranceSelectionnee"
        :live="liveSasAssurance(9209)"
        :filter="(fd) => filterCatalogueCategorie(fd)"
        :disabled="this.changementInterdit"
        @eudo-updated="updatePanier"
      />
      <CatalogueLive
        code="montant_garantie"
        v-model="sasAssurance.montantGarantie"
        :live="liveSasAssurance(9210)"
        @eudo-updated="updatePanier"
        :filter="(fd) => filterCatalogueMontant(fd)"
        :disabled="this.changementInterdit"
        orderBy="code"
      />

      <validate :that="!categorieIdentique || !couvertureIdentique" else="erreur_pas_de_changement" />

      <CatalogueLive
        code="motif_changement"
        v-model="sasAssurance.motifDuChangement"
        :live="liveSasAssurance(9212)"
        :disabled="sasAssurance.categorieDAssuranceLectureSeule"
      />
      <DatePickerLive
        code="date_changement"
        v-model="sasAssurance.dateDuChangement"
        :live="liveSasAssurance(9216)"
        :minValue="serverDateBefore22h00()"
        :maxValue="convertStrDateToString(sas.dateChangementMax)"
        :disabled="sasAssurance.categorieDAssuranceLectureSeule"
        @eudo-updated="updatePanier"
      />
    </v-form>
  </div>
</template>
<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import { mapActions } from "vuex"

export default {
  mixins: [CataloguesHelpers, DatesHelpers, StepFormWithValidation],
  props: {
    sas: { type: Object },
  },
  computed: {
    sasAssurance() {
      return this.sas.sasAssurance
    },
    autoriserChangementsCouverture() {
      return this.sasAssurance.autoriserChangementsCouverture
    },
    categorieActuelleEstA() {
      return this.sasAssurance.categorieActuelle === "A"
    },
    categorieActuelleEstB() {
      return this.sasAssurance.categorieActuelle === "B"
    },
    couvertureActuelleEst3M() {
      return this.sasAssurance.couvertureActuelle === "3M"
    },
    couvertureActuelleEst5M() {
      return this.sasAssurance.couvertureActuelle === "5M"
    },
    changementInterdit() {
      return (this.categorieActuelleEstA && this.couvertureActuelleEst5M)
        || (this.categorieActuelleEstA && this.couvertureActuelleEst3M && !this.autoriserChangementsCouverture)
    },
    categorieIdentique() {
      return (
        this.getCatalogueCodeById("7903", this.sasAssurance.categorieDAssuranceSelectionnee) ===
        this.sasAssurance.categorieActuelle
      )
    },
    couvertureIdentique() {
      return (
        this.getCatalogueCodeById("7904", this.sasAssurance.montantGarantie) === this.sasAssurance.couvertureActuelle
      )
    },
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    updatePanier() {
      this.fetchPanier({
        endpoint: "demande-changement-categorie-assurance",
        sasId: this.sas.id,
      })
    },
    liveSasAssurance(cle) {
      return {
        endpoint: "sas-assurance",
        cle: cle,
        fileId: this.sasAssurance.id,
      }
    },
    filterCatalogueCategorie(fd) {
      if (fd.code === "A") {
        return true
      }

      if (
        fd.code === "B" &&
        this.autoriserChangementsCouverture &&
        this.categorieActuelleEstB &&
        this.couvertureActuelleEst3M
      ) {
        return true
      }

      return false
    },
    filterCatalogueMontant(fd) {
      if (fd.code === "5M") {
        return true
      }

      if (fd.code === "3M" && this.categorieActuelleEstB && this.couvertureActuelleEst3M) {
        return true
      }

      return false
    },
  },
}
</script>

<style></style>
